module.exports = __webpack_public_path__ + "fab6c6019b3ec5288d9eb02de59fa62e.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/modules/header/components/images/header-bg.jpg
 ** module id = 1388
 ** module chunks = 0
 **/